"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var Metadata = function Metadata(_ref) {
  var _category$visibleTopi, _unreadTopicsAndRepli, _unreadTopicsAndRepli2, _unreadTopicsAndRepli3;

  var category = _ref.category,
      unreadTopicsAndRepliesCount = _ref.unreadTopicsAndRepliesCount;
  return (0, _preact.h)("ul", {
    className: (0, _classnames.default)('list', 'list--dot-seperated', 'text--meta', 'm-v-S')
  }, (0, _preact.h)("li", {
    className: "qa-forum-overview-topic-counter"
  }, (0, _preact.h)(_phrase.default, {
    p: "forumList.meta.counter.topic",
    count: {
      n: ((_category$visibleTopi = category === null || category === void 0 ? void 0 : category.visibleTopicsCount) !== null && _category$visibleTopi !== void 0 ? _category$visibleTopi : 0).toString()
    }
  }), (unreadTopicsAndRepliesCount === null || unreadTopicsAndRepliesCount === void 0 ? void 0 : (_unreadTopicsAndRepli = unreadTopicsAndRepliesCount[category.id]) === null || _unreadTopicsAndRepli === void 0 ? void 0 : _unreadTopicsAndRepli.topicCount) !== undefined ? (0, _preact.h)("span", {
    className: "qa-forum-overview-new-topics"
  }, "(", (0, _preact.h)(_phrase.default, {
    p: "forumList.meta.counter.topic.user.new",
    count: {
      n: ((_unreadTopicsAndRepli2 = (_unreadTopicsAndRepli3 = unreadTopicsAndRepliesCount[category.id]) === null || _unreadTopicsAndRepli3 === void 0 ? void 0 : _unreadTopicsAndRepli3.topicCount) !== null && _unreadTopicsAndRepli2 !== void 0 ? _unreadTopicsAndRepli2 : 0).toString()
    }
  }), ")") : null));
};

var _default = Metadata;
exports.default = _default;